import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Card } from '../Card';
import { Column } from '../Layout';
import { Typography } from '../Typography';
import styles from './SectionCard.module.scss';
export function SectionCard(_0) {
    let { title, testId, children } = _0, biProps = _object_without_properties(_0, [
        "title",
        "testId",
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Card, _object_spread_props(_object_spread({}, biProps), {
        skin: "white",
        borderSkin: "default",
        className: styles.root,
        testId: testId,
        children: /*#__PURE__*/ _jsxs(Column, {
            gap: 8,
            children: [
                title != null && /*#__PURE__*/ _jsx(Typography, {
                    variant: "h6",
                    weight: "bold",
                    className: styles.title,
                    testId: testId != null ? "".concat(testId, "-title") : undefined,
                    children: title
                }),
                children
            ]
        })
    }));
}
